import {ApiClient} from '@hconnect/apiclient'
import type {AxiosRequestHeaders, AxiosResponseHeaders} from 'axios'

export const fetchDownloadElectricityDataExcel = async (
  plantCode: string,
  createdByOptimiser?: boolean
): Promise<[Blob, AxiosResponseHeaders]> => {
  const {data, headers} = await ApiClient.axiosInstance.get<Blob>('/electricity', {
    params: {
      plantCode,
      ...(createdByOptimiser && {createdByOptimiser})
    },
    responseType: 'blob',
    transformRequest: (requestData, requestHeaders) => {
      ;(requestHeaders as AxiosRequestHeaders)['Accept'] =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      return requestData
    }
  })
  return [data, headers]
}
